import { TriggersPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/triggers/Index'

export const UnitTriggers = () => <TriggersPage />
